export default "__VITE_ASSET__BhbTgdeN__"